module.exports = __webpack_public_path__ + "static/img/ma10.30b5b21.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ma10.gif
// module id = knlR
// module chunks = 1